(() => {
  const header = document.querySelector('[data-site-header]');
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('#MobileMenu');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
    mobileMenu.addEventListener('click', event => {
      if (event.target.closest('a')) {
        menuButton.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
      }
    });
  }

  document.querySelectorAll('[data-design-catalog]').forEach(catalog => {
    const cards = [...catalog.querySelectorAll('[data-design-card]')];
    const filters = [...catalog.querySelectorAll('[data-design-filter]')];
    const search = catalog.querySelector('[data-design-search]');
    const empty = catalog.querySelector('[data-design-empty]');
    let activeFilter = 'all';
    let favoritesOnly=false,color='';
    let favorites=[];try{favorites=JSON.parse(localStorage.getItem('o2ThemeFavorites')||'[]');if(!Array.isArray(favorites))favorites=[];}catch{}
    const favoriteButtons=[...catalog.querySelectorAll('[data-theme-favorite]')];
    const paintFavorites=()=>favoriteButtons.forEach(b=>{const saved=favorites.includes(b.dataset.themeFavorite);b.textContent=saved?'♥':'♡';b.setAttribute('aria-pressed',saved)});paintFavorites();

    const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u064B-\u065F]/g, '').trim();
    const update = () => {
      const query = normalize(search?.value || '');
      let visible = 0;
      cards.forEach(card => {
        const categoryMatch = activeFilter === 'all' || card.dataset.category === activeFilter;
        const searchMatch = !query || normalize(card.dataset.search || '').includes(query);
        const fav=card.querySelector('[data-theme-favorite]');
        card.hidden = !(categoryMatch && searchMatch && (!color||normalize(card.dataset.search).includes(normalize(color))) && (!favoritesOnly||favorites.includes(fav.dataset.themeFavorite)));
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    };

    filters.forEach(button => button.addEventListener('click', () => {
      activeFilter = button.dataset.designFilter;
      filters.forEach(item => item.classList.toggle('active', item === button));
      update();
    }));
    search?.addEventListener('input', update);
    favoriteButtons.forEach(button=>button.addEventListener('click',()=>{const id=button.dataset.themeFavorite;favorites=favorites.includes(id)?favorites.filter(x=>x!==id):[...favorites,id];try{localStorage.setItem('o2ThemeFavorites',JSON.stringify(favorites))}catch{}paintFavorites();update();}));
    catalog.querySelector('[data-color-filter]').addEventListener('change',event=>{color=event.target.value;update();});
    catalog.querySelector('[data-favorites-filter]').addEventListener('click',event=>{favoritesOnly=!favoritesOnly;event.currentTarget.setAttribute('aria-pressed',favoritesOnly);update();});
  });

  const productRoot = document.querySelector('[data-product-root]');
  if (!productRoot) return;

  const form = productRoot.querySelector('[data-product-form]');
  const variantInput = productRoot.querySelector('[data-variant-id]');
  const variantsNode = productRoot.querySelector('[data-product-variants]');
  const pricesNode = productRoot.querySelector('[data-variant-prices]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  const formattedPrices = pricesNode ? JSON.parse(pricesNode.textContent) : {};
  const optionGroups = [...productRoot.querySelectorAll('[data-option-position]')];
  const designSelect = productRoot.querySelector('[data-design-select]');
  const productImage = productRoot.querySelector('[data-product-image], .main-product-image');
  const designMap = new Map([...productRoot.querySelectorAll('[data-design-map] [data-design]')].map(item => [item.dataset.design, item.dataset.src]));
  const phraseSelect = productRoot.querySelector('[data-phrase-select]');
  const customPhrase = productRoot.querySelector('[data-custom-phrase]');
  const quantity = productRoot.querySelector('[data-product-quantity]');
  const addButton = productRoot.querySelector('[data-add-to-cart]');
  const status = productRoot.querySelector('[data-product-status]');

  const selectedOptions = () => optionGroups.map(group => {
    if(group.querySelector('[data-blanket-toggle]'))return group.querySelector('[data-blanket-option]').value;
    const checked = group.querySelector('input:checked');
    const select = group.matches('label') ? group.querySelector('select') : group.querySelector('select');
    return checked?.value || select?.value || '';
  });

  const updateVariant = () => {
    const selected = selectedOptions();
    const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
    if (!variant) {
      addButton.disabled = true;
      addButton.querySelector('span').textContent = 'الخيار غير متوفر';
      return;
    }
    variantInput.value = variant.id;
    addButton.disabled = !variant.available;
    addButton.querySelector('span').textContent = variant.available ? 'أضف للسلة' : 'غير متوفر';
    const price = formattedPrices[String(variant.id)] || '';

    const design = designSelect?.value;
    if (design && designMap.has(design) && productImage) {
      productImage.src = designMap.get(design);
      productImage.alt = `طقم ${design} من O2 Baby`;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    if (design) url.searchParams.set('design', design);
    window.history.replaceState({}, '', url);
  };

  const requestedDesign = new URLSearchParams(window.location.search).get('design');
  if (requestedDesign && designSelect && [...designSelect.options].some(option => option.value === requestedDesign)) {
    designSelect.value = requestedDesign;
  }

  productRoot.querySelector('[data-blanket-toggle]')?.addEventListener('change',event=>{const select=productRoot.querySelector('[data-blanket-option]');const option=[...select.options].find(x=>event.target.checked ? x.value==='مع بطانية' : x.value==='بدون بطانية');if(option)select.value=option.value;});
  optionGroups.forEach(group => group.addEventListener('change', updateVariant));
  updateVariant();

  phraseSelect?.addEventListener('change', () => {
    const show = phraseSelect.value === 'عبارة خاصة';
    customPhrase.hidden = !show;
    const input = customPhrase.querySelector('input');
    input.disabled = !show;
    input.required = show;
    if (show) input.focus();
  });

  productRoot.querySelector('[data-product-qty-minus]')?.addEventListener('click', () => {
    quantity.value = String(Math.max(1, Number(quantity.value) - 1));
  });
  productRoot.querySelector('[data-product-qty-plus]')?.addEventListener('click', () => {
    quantity.value = String(Math.min(10, Number(quantity.value) + 1));
  });

  form?.addEventListener('submit', async event => {
    event.preventDefault();
    addButton.disabled = true;
    addButton.querySelector('span').textContent = 'جاري الإضافة...';
    status.textContent = '';

    try {
      const values=new FormData(form);
      const properties=Object.fromEntries([...values.entries()].filter(([key])=>key.startsWith('properties[')).map(([key,value])=>[key.slice(11,-1),value]));
      const items=[{id:values.get('id'),quantity:Number(values.get('quantity')),properties}];
      productRoot.querySelectorAll('[data-extra-variant]:checked').forEach(input=>items.push({id:input.dataset.extraVariant,quantity:Number(values.get('quantity')),properties:{'اسم البيبي':properties['اسم البيبي']||'', 'للطقم':designSelect?.value||''}}));
      const check=await fetch((window.Shopify?.routes?.root||'/')+'cart.js');
      if(!check.ok)throw Error('تعذر التحقق من السلة. حاول مرة ثانية.');
      const existing=await check.json();const signature=x=>JSON.stringify(Object.entries(x||{}).filter(([,v])=>v!=='').sort(([a],[b])=>a.localeCompare(b)));
      if(existing.items.some(x=>String(x.variant_id)===String(items[0].id)&&signature(x.properties)===signature(properties))&&!confirm('هذا الطقم بنفس التفاصيل موجود بالسلة. موافق: زيادة الكمية. إلغاء: تعديل الاسم لطلب آخر.')){addButton.disabled=false;addButton.querySelector('span').textContent='أضف للسلة';form.querySelector('[name="properties[اسم البيبي]"]').focus();return;}
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        body: JSON.stringify({items}),
        headers: { Accept: 'application/json', 'Content-Type':'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'تعذرت إضافة المنتج');

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      document.querySelectorAll('.cart-count').forEach(node => node.textContent = cart.item_count);
      status.innerHTML = `تمت إضافة الطقم للسلة. <a href="/cart">عرض السلة</a>`;
      addButton.querySelector('span').textContent = 'تمت الإضافة ✓';
      setTimeout(() => {
        addButton.disabled = false;
        addButton.querySelector('span').textContent = 'أضف للسلة';
      }, 1800);
    } catch (error) {
      status.textContent = error.message;
      addButton.disabled = false;
      addButton.querySelector('span').textContent = 'أضف للسلة';
    }
  });
})();
